module.exports = __webpack_public_path__ + "img/usa-respiratory-diseases-male.5126cbec.png";